import { render, staticRenderFns } from "./Sammelvertragspreise.vue?vue&type=template&id=5c679993&scoped=true"
import script from "./Sammelvertragspreise.vue?vue&type=script&lang=js"
export * from "./Sammelvertragspreise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c679993",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c679993')) {
      api.createRecord('5c679993', component.options)
    } else {
      api.reload('5c679993', component.options)
    }
    module.hot.accept("./Sammelvertragspreise.vue?vue&type=template&id=5c679993&scoped=true", function () {
      api.rerender('5c679993', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Sammelvertragspreise.vue"
export default component.exports